import { render, staticRenderFns } from "./category-tree-item.vue?vue&type=template&id=5d2acbc2&scoped=true&"
import script from "./category-tree-item.vue?vue&type=script&lang=js&"
export * from "./category-tree-item.vue?vue&type=script&lang=js&"
import style0 from "./category-tree-item.vue?vue&type=style&index=0&id=5d2acbc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2acbc2",
  null
  
)

export default component.exports